// react
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';

// type
import { GuardPropsType } from 'types';
import { CLOUD_BASE_PATH } from 'utils/constants';

const AuthGuard = ({ children }: GuardPropsType) => {
  const { isLoggedIn, isValidEmail } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const basePath = location.pathname.startsWith(CLOUD_BASE_PATH) ? CLOUD_BASE_PATH : '/rental';
    if (!isLoggedIn) {
      navigate(`${basePath}/login`, {
        state: {
          from: null
        },
        replace: true
      });
    }

    if (!isValidEmail && location.pathname.indexOf(`${basePath}/mypage/customer`) === -1) {
      navigate(`${basePath}/mypage/customer`, {
        state: {
          from: null
        },
        replace: true
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, isValidEmail, location]);

  return children;
};

export default AuthGuard;
